(() => {
  function initSection(root) {
    if (!root || root.dataset.ctsInit === "1") return;
    root.dataset.ctsInit = "1";

    const tabs = Array.from(root.querySelectorAll(".cts__tab"));
    const panels = Array.from(root.querySelectorAll(".cts__panel"));

    function initSlider(panel) {
      const track = panel.querySelector("[data-track]");
      const prev = panel.querySelector("[data-prev]");
      const next = panel.querySelector("[data-next]");
      if (!track || !prev || !next) return;

      const getStep = () => {
      const ITEMS_PER_CLICK = 2; // 1 = ühe kaardi võrra, 2 = kahe kaardi võrra jne

      const item = track.querySelector(".cts__item");
      if (!item) return Math.max(240, Math.floor(track.clientWidth * 0.85));

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || "18") || 18;

      return (item.getBoundingClientRect().width + gap) * ITEMS_PER_CLICK;
      };


      const update = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        const x = track.scrollLeft;
        prev.disabled = x <= 2;
        next.disabled = x >= maxScroll - 2;
      };

      prev.addEventListener("click", () => track.scrollBy({ left: -getStep(), behavior: "smooth" }));
      next.addEventListener("click", () => track.scrollBy({ left: getStep(), behavior: "smooth" }));
      track.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    }

    function activate(panelId) {
      tabs.forEach((t) => {
        const on = t.dataset.target === panelId;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach((p) => p.classList.toggle("is-active", p.id === panelId));

      const active = root.querySelector("#" + (window.CSS && CSS.escape ? CSS.escape(panelId) : panelId));
      if (active) initSlider(active);
    }

    tabs.forEach((t) => t.addEventListener("click", () => activate(t.dataset.target)));

    const firstActive = root.querySelector(".cts__panel.is-active");
    if (firstActive) initSlider(firstActive);
  }

  function initAll() {
    document.querySelectorAll(".cts[data-cts]").forEach(initSection);
  }

  // run now OR on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Theme editor
  document.addEventListener("shopify:section:load", (e) => {
    const root = e.target.querySelector(".cts[data-cts]");
    if (root) initSection(root);
    else initAll();
  });
  document.addEventListener("shopify:section:select", initAll);
})();
